var exports = {
  "gX": "ShopierCheckoutModal.module__center___dEV5cU",
  "rf": "ShopierCheckoutModal.module__body___dEV5cU",
  "Qq": "ShopierCheckoutModal.module__text___dEV5cU",
  "IT": "ShopierCheckoutModal.module__codeRow___dEV5cU",
  "aY": "ShopierCheckoutModal.module__code___dEV5cU",
  "cL": "ShopierCheckoutModal.module__copyButton___dEV5cU",
  "h5": "ShopierCheckoutModal.module__status___dEV5cU",
  "u1": "ShopierCheckoutModal.module__spinner___dEV5cU",
  "t0": "ShopierCheckoutModal.module__spin___dEV5cU",
  "kX": "ShopierCheckoutModal.module__success___dEV5cU",
  "QK": "ShopierCheckoutModal.module__successTitle___dEV5cU",
};

module.exports = exports;
